import React from 'react'

export default function Item({ link, handleResend, modal, index }) {
  let dateString = link && link.dateRegister ? link.dateRegister : ''
  let finalDateString = dateString.split(/[ /]+/)

  return (
    <tr>
      {!modal && (
        <td style={{ padding: '0px 5px' }}>
          <input
            style={{ cursor: 'pointer' }}
            type="checkbox"
            onChange={(e) => handleResend(link, e.target.checked)}
            className="check-items"
          />
        </td>
      )}
      <td>{link._id}</td>
      <td>{link.name}</td>
      <td>{link.email}</td>
      <td>
        {finalDateString[2]}/{finalDateString[1]}/{finalDateString[0]}
      </td>
      <td>
        <span></span>
      </td>
      <td className={modal ? `modal-${index}` : `list-${index}`}>
        <span className={link.statusEquifax === false ? 'error' : ''}></span>
      </td>
    </tr>
  )
}
